import type { FolderUser, FolderUserUpdate } from '../../types';
import { Avatar, P } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { getColorsForAvatar, getLettersForAvatar } from '~/utils/avatar';
import { getCurrentUser } from '~/common/explicit-exports';
import {
  PermissionContainer,
  PermissionDetailsContainer,
  PermissionNameContainer,
  PermissionEmail,
} from './FolderPermission.styles';
import { PermissionAccessLevelMenu } from './PermissionAccessLevelMenu';

type Props = {
  folderUser: FolderUser;
  readOnly: boolean;
  onUpdate: (data: FolderUserUpdate) => void;
};

export const FolderPermission = ({
  onUpdate,
  readOnly,
  folderUser: { displayName, imgUrl, email, userId, groupId, accessLevel, inheritedFolder },
}: Props) => {
  const theme = useTheme();

  const {
    enterprise: { scheme_color: brandColor },
  } = getCurrentUser();

  const colors = getColorsForAvatar(theme, brandColor);
  const iconName = groupId !== null ? 'company:regular' : undefined;
  const letters = userId !== null ? getLettersForAvatar(displayName) : undefined;

  return (
    <PermissionContainer>
      <PermissionDetailsContainer>
        <Avatar imgUrl={imgUrl} letters={letters} iconName={iconName} {...colors} />
        <PermissionNameContainer>
          <P density="sm" size={1}>
            {displayName}
          </P>
          {email && (
            <PermissionEmail density="xs" size={0}>
              {email}
            </PermissionEmail>
          )}
        </PermissionNameContainer>
      </PermissionDetailsContainer>
      <PermissionAccessLevelMenu
        userId={userId}
        groupId={groupId}
        onUpdate={onUpdate}
        accessLevel={accessLevel}
        inheritedFolder={inheritedFolder}
        readOnly={readOnly}
      />
    </PermissionContainer>
  );
};
